import badgeTypes from '../consts/loyalty/badgeTypes';
import {MODAL_TYPES} from '../consts/modal/modalTypes';
import pushNotificationDestinationTypes from '../consts/notification/pushNotificationDestinationTypes';
import pushNotificationSystemSubTypes from '../consts/notification/pushNotificationSystemSubTypes';
import routes from '../consts/routes';
import {setCurrentBadge} from '../state/slice/loyalty';
import {
    showContactUsModal,
    showHighTemperatureModal,
    showModal,
    showNotificationsFeedbackModal,
} from '../state/slice/modal';
import {dispatch} from '../state/store';
import routerService from './router/routerService';

const SUB_TYPE_MODAL_ACTIONS = {
    [pushNotificationSystemSubTypes.EXP_COACH_DEVICE_OVERHEATING_DETECTED]: showHighTemperatureModal,
};

const getRouteByDestinationType = ({destinationType, isNativeNotification, notificationSubType}) => {
    switch (destinationType) {
        case pushNotificationDestinationTypes.FLEX_PUFF:
            return {route: routes.FLEX_PUFF, isBackRouteAvailable: true, isDeviceRequired: true};
        case pushNotificationDestinationTypes.FLEX_BATTERY:
            return {route: routes.FLEX_BATTERY, isBackRouteAvailable: true, isDeviceRequired: true};
        case pushNotificationDestinationTypes.PAUSE_MODE:
            return {route: routes.PAUSE_MODE, isBackRouteAvailable: true, isDeviceRequired: true};
        case pushNotificationDestinationTypes.SOFTWARE_UPDATE:
            return {route: routes.DEVICE_FWU_CHECK, isBackRouteAvailable: true, isDeviceRequired: true};
        case pushNotificationDestinationTypes.LOYALTY:
            return {route: routes.CLUB_WELCOME};
        case pushNotificationDestinationTypes.LOYALTY_BADGES:
            return {route: routes.CLUB, isBackRouteAvailable: true};
        case pushNotificationDestinationTypes.CONVERSION_BADGE:
            dispatch(setCurrentBadge(badgeTypes.SWITCH_MASTER));
            return {route: routes.CLUB_BADGE, isBackRouteAvailable: true};
        case pushNotificationDestinationTypes.LOW_PERFORMANCE:
            return {route: routes.NOTIFICATIONS, isBackRouteAvailable: true};
        case pushNotificationDestinationTypes.USAGE:
        case pushNotificationDestinationTypes.EXPERIENCE_COACH:
            const showModalAction = SUB_TYPE_MODAL_ACTIONS[notificationSubType];

            if (showModalAction) {
                dispatch(showModalAction());
                return {route: null, isBackRouteAvailable: null};
            }
            return {route: routerService.getInsightRoute(), isDeviceRequired: true};
        case pushNotificationDestinationTypes.HOME:
            return {route: routes.HOME};
        case pushNotificationDestinationTypes.NOTIFICATIONS:
            if (isNativeNotification) {
                return {route: routes.HOME};
            }
            return {route: routes.NOTIFICATIONS, isBackRouteAvailable: true};
        case pushNotificationDestinationTypes.CONTACT_US:
            dispatch(showContactUsModal());
            return {route: routes.CLUB_WELCOME};
        case pushNotificationDestinationTypes.VISIT_STORES:
            dispatch(showModal({modalType: MODAL_TYPES.RETAIL_FEEDBACK_MODAL}));
            return {route: routes.CLUB_WELCOME};
        case pushNotificationDestinationTypes.END_FEEDBACK:
            dispatch(showNotificationsFeedbackModal());
            return {route: null, isBackRouteAvailable: null};
        default:
            return {route: routes.HOME};
    }
};

export {getRouteByDestinationType};
